import * as React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { LocalTimeRead } from '../../../../models/utilities/local-time-read';
import { StatusCode } from '../../../../utils/api';
import { ShipmentType } from '../../../models/enums/shipment-type';
import { OrderSummary } from '../../../models/shared/order-summary';
import { RunningTotal } from '../../../models/shared/running-total';
import { DeliveryShipmentAction } from '../../../models/shipments/shipment-action';
import { DeliveryShipmentActionCreate } from '../../../models/shipments/shipment-action-create';
import { DeliveryShipmentActionCreateFull } from '../../../models/shipments/shipment-action-create-full';
import { TransportationSvc } from '../../../service';
import { ShipmentEditCustomerDelivery } from '../ShipmentEditCustomerDelivery';
import { CreateCustomerDeliveryStepOne } from './CreateCustomerDeliveryStepOne';

interface IProps {
    onSuccess       : any;
    onCancel        : any;
    entityType      : ShipmentType;
    truckId         : number;
    serviceCenterId : string;
    truckVersion    : string;
    truckTotals     : RunningTotal|undefined;
}

export const CreateCustomerDeliveryWizard = (props : IProps) => {

    const STEP_ONE = 0;
    const STEP_TWO = 1;

    const [service]                     = React.useState(new TransportationSvc());
    const [currentStep, setCurrentStep] = React.useState(STEP_ONE);
    const [editStop, setEditStop]       = React.useState<DeliveryShipmentAction>(new DeliveryShipmentAction());
    const [orderList, setOrderList]     = React.useState<OrderSummary[]>([]);

    const prepForAdvanced = (itm : DeliveryShipmentActionCreateFull) => {

        const t                 = new DeliveryShipmentAction();
        t.shipToAddressId       = itm.shipToAddressId;
        t.dealerId              = itm.dealerId;
        t.fixedFreightAmount    = itm.fixedFreightAmount;
        t.address               = itm.address.address;

        if (itm.stopTimeLocal) {
            t.actionTime          = new LocalTimeRead();
            t.actionTime.local    = itm.stopTimeLocal;
        }
        
        setEditStop(t);
        setOrderList(itm.openOrders);
        setCurrentStep(STEP_TWO);
    };

    const onSave = async (newStop : DeliveryShipmentActionCreate) => {
        const result = await service.addNewStop(newStop, props.truckId, props.entityType);
        if (result.status === StatusCode.Success) {
            props.onSuccess();
        }
    };

    const onBackToAddress = () => {
        setCurrentStep(STEP_ONE);
    };

    const renderComponent = () => {
        switch (currentStep) {
            case STEP_ONE:
                return <CreateCustomerDeliveryStepOne
                    truckId={props.truckId}
                    serviceCenterId={props.serviceCenterId}
                    truckVersion={props.truckVersion}
                    onAdvancedEdit={prepForAdvanced}
                    onSave={onSave}
                    onCancel={props.onCancel} />;
            case STEP_TWO:
                return <div className="stop-action-edit-delivery">
                    <ShipmentEditCustomerDelivery
                        stop={editStop}
                        isQuickCreate={false}
                        orderList={orderList}
                        onSave={onSave}
                        updateStops={undefined}
                        updateTruck={undefined}
                        onCancel={props.onCancel}
                        entityType={props.entityType}
                        changeAddress={onBackToAddress}
                        visible={true}
                        truckId={props.truckId}                        
                        truckVersion={props.truckVersion}
                        truckTotals={props.truckTotals}
                        serviceCenterId={props.serviceCenterId}
                    />
                </div>;
            default:
                return null;
        }
    };

    return <div className={`wizard-wrapper ${currentStep === 1 ? 'reverse' : ''}`}>
            <TransitionGroup>
                <CSSTransition
                    key={ currentStep }
                    timeout={{ enter: 500, exit: 500 }}
                    classNames="wizard-slide">
                    { renderComponent() }
                </CSSTransition>
            </TransitionGroup>     
             
        </div>;
};
